<vi-page [sidenavs]="true" [footer]="true" [isWhiteBackground]="true">
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>
  <vi-toolbar head color="white">
    <vi-back-button left gtm="onBreadcrumbBack" gtmCategory="booking"></vi-back-button>
    <vi-breadcrumbs
      left
      gtm="onBreadcrumb"
      gtmCategory="booking"
      formerPage="{{ 'GENERAL.PATH.OVERVIEW' | translate }}"
      currentPage="{{ 'GENERAL.PATH.BOOKING_OVERVIEW' | translate }}"
      [navigateTo]="'/installations'"
    ></vi-breadcrumbs>
  </vi-toolbar>

  <vi-content body layoutAlign="justify-start items-start">
    <ng-container
      *ngIf="
        (installationsStore.loaded$ | async) && (bookingStore.bookingViewLoaded$ | async);
        else loader
      "
      main
    >
      <div
        class="packages-header flex flex-row justify-between items-center w-full min-w-full h-full min-h-full"
      >
        <h1 data-at-title>
          {{ '+BOOKING.OVERVIEW.TITLE' | translate }}
        </h1>
        <app-installation-search
          search
          [searchTerm]="searchTerm"
          categoryForGtm="bookingOverview"
          (search)="search($event)"
          (clear)="setDefaultSubscriptions()"
        ></app-installation-search>
      </div>

      <ng-container
        *ngIf="
          (remoteConfigStore.isHardwareBundlingAvailable$ | async) &&
            bookingStore.contingentSubscriptions$ | async as contingentSubscriptions
        "
      >
        <app-booking-contingent-subscription-list
          *ngIf="contingentSubscriptions?.length"
          [contingentSubscriptions]="contingentSubscriptions"
        ></app-booking-contingent-subscription-list>
      </ng-container>

      <app-booking-unregistered-list
        *ngIf="unregisteredSubscriptions.length"
        [unregisteredSubscriptions]="unregisteredSubscriptions"
      ></app-booking-unregistered-list>

      <ng-container
        *ngIf="bookingStore.trialSubscriptionsActive$ | async as trialSubscriptionsActive"
      >
        <app-booking-extend-trial-list
          *ngIf="trialSubscriptionsActive?.length"
          class="full-width"
          [searchTerm]="searchTerm"
        ></app-booking-extend-trial-list>
      </ng-container>

      <h2 data-at-title>
        {{ '+BOOKING.OVERVIEW.PACKAGES.ACTIVE' | translate }}
      </h2>
      <div
        class="filter-header flex gt-sm:flex-row lt-md:flex-col gap-[24px] lt-md:gap-[16px] justify-between items-center"
      >
        <div
          class="chip-filters__wrapper gap-[24px] flex xs:flex-col gt-xs:flex-row xs:justify-center xs:items-center gt-xs:justify-start gt-xs:items-baseline"
        >
          <app-chip-filters [layoutGap]="'8px'">
            <app-chip-filter
              *ngIf="showAllAndPlusSubscriptionsFilters"
              data-at-filter-all-subscriptions
              [attr.data-at-active]="activeSubscriptionsFilter === filterType.ALL"
              [active]="activeSubscriptionsFilter === filterType.ALL"
              [count]="proAndPlusSubscriptions.length"
              gtm="onSetFilter"
              gtmAction="Pro & Plus"
              gtmCategory="bookingOverview"
              (click)="setFilter(filterType.ALL)"
              >{{ '+BOOKING.OVERVIEW.FILTER.ALL' | translate }}</app-chip-filter
            >
            <app-chip-filter
              data-at-filter-pro-subscriptions
              [attr.data-at-active]="activeSubscriptionsFilter === filterType.PRO"
              [active]="activeSubscriptionsFilter === filterType.PRO"
              [count]="proSubscriptions.length"
              gtm="onSetFilter"
              gtmAction="Pro"
              gtmCategory="bookingOverview"
              (click)="setFilter(filterType.PRO)"
              >{{ '+BOOKING.OVERVIEW.FILTER.PRO' | translate }}</app-chip-filter
            >
            <app-chip-filter
              *ngIf="showAllAndPlusSubscriptionsFilters && plusSubscriptions.length"
              data-at-filter-plus-subscriptions
              [attr.data-at-active]="activeSubscriptionsFilter === filterType.PLUS"
              [active]="activeSubscriptionsFilter === filterType.PLUS"
              [count]="plusSubscriptions.length"
              gtm="onSetFilter"
              gtmAction="Plus"
              gtmCategory="bookingOverview"
              (click)="setFilter(filterType.PLUS)"
              >{{ '+BOOKING.OVERVIEW.FILTER.PLUS' | translate }}</app-chip-filter
            >
            <app-chip-filter
              *ngIf="
                automaticExtensionSubscriptions.length &&
                (remoteConfigStore.isHardwareBundlingAvailable$ | async)
              "
              data-at-filter-automatic-extension-subscriptions
              [attr.data-at-active]="activeSubscriptionsFilter === filterType.AUTOMATIC_EXTENSION"
              [active]="activeSubscriptionsFilter === filterType.AUTOMATIC_EXTENSION"
              [count]="automaticExtensionSubscriptions.length"
              gtm="onSetFilter"
              gtmAction="Automatic extension"
              gtmCategory="bookingOverview"
              (click)="setFilter(filterType.AUTOMATIC_EXTENSION)"
              >{{ '+BOOKING.OVERVIEW.FILTER.AUTOMATIC_EXTENSION' | translate }}</app-chip-filter
            >
          </app-chip-filters>
          <mat-checkbox
            checked="isCancelledPackagesShown"
            (change)="showCancelledPackages()"
            gtm="onToggle"
            gtmAction="Show cancelled packages checkbox"
            gtmCategory="bookingOverview"
            >{{ '+BOOKING.OVERVIEW.FILTER.SHOW_CANCELLED_PACKAGES' | translate }}</mat-checkbox
          >
        </div>
      </div>

      <app-booking-subscription-list
        data-at-active-subscriptions
        [subscriptions]="activeSubscriptions"
        [activeSubscriptionsFilter]="activeSubscriptionsFilter"
        [searchTerm]="searchTerm"
      ></app-booking-subscription-list>

      <ng-container *ngIf="isCancelledPackagesShown">
        <h2 data-at-title>
          {{ '+BOOKING.OVERVIEW.PACKAGES.EXPIRED' | translate }}
        </h2>
        <ng-container *ngIf="displayedExpiredSubscriptions?.length; else noExpiredPackages">
          <app-booking-subscription-list
            data-at-expired-subscriptions
            [subscriptions]="displayedExpiredSubscriptions"
            [searchTerm]="searchTerm"
          ></app-booking-subscription-list>
        </ng-container>
        <ng-template #noExpiredPackages>
          <app-no-search-results
            class="w-full min-w-full h-full min-h-full"
            *ngIf="searchTerm; else noExpiredPackagesMessage"
            [searchTerm]="searchTerm"
          ></app-no-search-results>
          <ng-template #noExpiredPackagesMessage>
            <div
              class="flex flex-row justify-center items-center w-full min-w-full h-full min-h-full"
            >
              {{ '+BOOKING.OVERVIEW.PACKAGES.NO_EXPIRED_PACKAGES' | translate }}
            </div>
          </ng-template>
        </ng-template>
      </ng-container>
    </ng-container>

    <ng-template #loader>
      <vi-loader main [isLoading]="true"></vi-loader>
    </ng-template>
  </vi-content>

  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
